import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import NoiseFrame from '../../../../assets/noise/watch-empty.webp';
import noiseimg from '../../../../assets/noise/noiseimg.png';
import leftArrow from '../../../../assets/noise/left.svg';
import rightArrow from '../../../../assets/noise/right.svg';
import './NoiseBeforeTheRideCarousel.scss';
import { pushToDataLayerEvents } from '../../../../dataLayer.js'; // adjust path as needed
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';

const NoiseBeforeTheRideCarousel = ({ fields }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState(fields.CarouselCards.length - 1);
  const [nextSlide, setNextSlide] = useState(1);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const threshold = 50;
  const brandName = useContext(LayoutDetailsContext);

  const pushToDataLayer = (currentSlide, interactionType) => {
    const currentCard = fields.CarouselCards[currentSlide];
    dataLayer.push({
      event: 'Banner_Navigation',
      eventCategory: 'Banner Navigation',
      eventAction: interactionType,
      eventLabel: currentCard.name,
      section_name: 'Before You Move',
      // banner_name: currentCard.name,
      // cta_text: interactionType,
      BrandName: 'TVS iQube',
      // section_name: 'Noise',
    });
  };

  const updateSlides = (newCurrent, interactionType = 'auto') => {
    setCurrentSlide(newCurrent);
    setPrevSlide((newCurrent - 1 + fields.CarouselCards.length) % fields.CarouselCards.length);
    setNextSlide((newCurrent + 1) % fields.CarouselCards.length);
    pushToDataLayer(newCurrent, interactionType);
  };

  const goToNext = useCallback(() => {
    updateSlides((currentSlide + 1) % fields.CarouselCards.length, 'right_arrow');
  }, [currentSlide, fields.CarouselCards.length]);

  const goToPrev = useCallback(() => {
    updateSlides(
      (currentSlide - 1 + fields.CarouselCards.length) % fields.CarouselCards.length,
      'left_arrow'
    );
  }, [currentSlide, fields.CarouselCards.length]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const deltaX = touchStartX.current - touchEndX.current;

    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
  };

  useEffect(() => {
    updateSlides(0);
  }, [fields.CarouselCards.length]);

  const getSlideClass = (index) => {
    if (index === currentSlide) return 'active';
    if (index === prevSlide) return 'prev';
    if (index === nextSlide) return 'next';
    return '';
  };

  const goToSlide = useCallback((index) => {
    updateSlides(index, 'dot_click');
  }, []);

  return (
    <div className="noise-before-ride-wrapper">
      {/* <SmartXonnectUsage />  */}
      <div className="before-ride-section" data-aos="fade-up">
        <h1 className="yourride gotham-medium">Your Ride, Connected Across Every Journey</h1>
        <div className="header-section">
          <h2 className="before-ride-header gotham-medium">{fields?.Title?.value}</h2>
          <p className="subtitle gotham-medium">{fields?.Heading?.value}</p>
        </div>
        <div
          className="carousel-container"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="phone-frame-container">
            <img src={NoiseFrame} alt="Phone frame" className="phone-frame" loading="lazy" />
            {/* <h2 className="card-main-header">{fields.CarouselCards[currentSlide].name}</h2> */}
          </div>
          <div className="carousel-slides">
            {fields.CarouselCards.map((image, index) => (
              <div key={index} className={`carousel-slide ${getSlideClass(index)}`}>
                <div className="image-container">
                  <img
                    src={image?.fields?.CardMedia?.value?.src}
                    alt={image?.fields?.CardMedia?.value?.alt}
                    className="carousel-image"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
          <img
            src={leftArrow}
            alt="Left Arrow"
            className="left-arrow"
            onClick={goToPrev}
            loading="lazy"
          />
          <img
            src={rightArrow}
            alt="Right Arrow"
            className="right-arrow"
            onClick={goToNext}
            loading="lazy"
          />
          <div className="carousel-indicators">
            {fields.CarouselCards.map((_, index) => (
              <div
                key={index}
                className={`indicator-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
        <div className="carousel-content">
          <div className="carousel-footer-section">
            <h3 className="card-header gotham-medium">
              {fields.CarouselCards[currentSlide].fields.CardTitle.value}
            </h3>
            <p className="card-sub-header gotham-medium">
              {fields.CarouselCards[currentSlide].fields.CardSubtitle.value}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(NoiseBeforeTheRideCarousel);
